import $ from 'jquery';

// Check for hash in url and if it contains the word 'accordion', it true, scroll to and open
$(function () {
  if (window.location.hash) {
    const hash = window.location.hash;
    if (document.querySelector(hash) && hash.includes('accordion')) {
      $([document.documentElement, document.body]).animate(
        {
          scrollTop: $(hash).offset().top - 300
        },
        2000
      );
      $(hash).addClass('toggle__switch--on');
      $(hash).next().addClass('toggle__target--visible');
    }
  }
});
